import React from 'react';
import {useNavigate} from "react-router-dom";
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

export default function SideNavItem(props) {

    const {color="primary"} = props;


    const navigate = useNavigate();

    const clicked = (event) => {
        props.setSelected(props.name);
        props.toggleSide(false)(event);
        navigate(props.link);
    }

    return(
        <ListItem selected={props.selected} button key={props.name} onClick={clicked}>
            <ListItemIcon>{props.icon}</ListItemIcon>
            <ListItemText primaryTypographyProps={{color: color}} primary={props.name}/>
        </ListItem>
    )
}